module.exports = __webpack_public_path__ + "static/img/Reza.d807c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Reza.jpg
// module id = 8fJ7
// module chunks = 1